import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      headerConfig: 'Header Configuration',
      footerConfig: 'Footer Configuration',
      sectionExterior: 'Exterior',
      sectionInterior: 'Interior',
      border: 'Border',
      borderColor: 'Border Color',
      backgroundColor: 'Background Color',
      height: 'Height',
      borderRadius: 'Border Radius',
      borderWidth: 'Border Width',
      bgImage: 'Background Image',
      textLayerOptions: 'Text Layer Options',
      editor: 'Text Editor',
      reset: 'Reset',
      selectLanguage: 'Select Language',
      accordionConfig: 'Accordion Configuration',
      addTab: 'Add Tab',
      removeTab: 'Remove Tab',
      save: 'Save',
      selectIcon: 'Select Icon',
      removeIcon: 'Remove Icon',
      chooseIcon: 'Choose Icon',
      close: 'Close',
      loading: 'Loading…',
      headerLabel: 'Header (click to configure)',
      footerLabel: 'Footer (click to configure)',
      infoTitle: 'Information',
      activeTabs: 'Active Tabs',
      selectedTab: 'Selected Tab',
      activeElement: 'Active Element',
      tabTitleLabel: 'Tab Title',
      updateTitle: 'Update Title',
      infoDesc: 'Use this section to display additional information or options.',
      none: 'None',
      select: 'Select',
      textLayerBorder: 'Text Layer Border',
      textBorderColor: 'Text Border Color',
      textBackgroundColor: 'Text Background Color',
      textBorderWidth: 'Text Border Width',
      textBorderRadius: 'Text Border Radius',
      resetBorderColor: 'Reset Border Color',
      resetBackgroundColor: 'Reset Background Color',
      resetTextBorderColor: 'Reset Text Border Color',
      resetTextBackgroundColor: 'Reset Text Background Color',
      resetBodyBackgroundColor: 'Reset Body Background Color',
      transparentColorDisabled: 'Color picker disabled (transparent)',
      setOpaque: 'Set opaque',
      setTransparent: 'Set transparent',
      resetColor: 'Reset color',
    }
  },
  fr: {
    translation: {
      headerConfig: "Configuration de l'entête",
      footerConfig: 'Configuration du pied',
      sectionExterior: 'Extérieur',
      sectionInterior: 'Intérieur',
      border: 'Bordure',
      borderColor: 'Couleur bordure',
      backgroundColor: 'Couleur fond',
      height: 'Hauteur',
      borderRadius: 'Arrondi',
      borderWidth: 'Épaisseur',
      bgImage: 'Image de fond',
      textLayerOptions: 'Options Calque',
      editor: 'Éditeur de texte',
      reset: 'Réinitialiser',
      selectLanguage: 'Choisir la langue',
      accordionConfig: 'Configuration de l\'accordéon',
      addTab: 'Ajouter un onglet',
      removeTab: 'Supprimer l\'onglet',
      save: 'Sauvegarder',
      selectIcon: 'Sélectionner icône',
      removeIcon: 'Supprimer icône',
      chooseIcon: 'Choisissez une icône',
      close: 'Fermer',
      loading: 'Chargement…',
      headerLabel: 'Entête (cliquez pour activer)',
      footerLabel: 'Pied (cliquez pour activer)',
      infoTitle: 'Informations',
      activeTabs: 'Onglets actifs',
      selectedTab: 'Onglet sélectionné',
      activeElement: 'Élément actif',
      tabTitleLabel: 'Titre de l\'onglet',
      updateTitle: 'Mettre à jour le titre',
      infoDesc: 'Utilisez cette section pour afficher des informations supplémentaires ou des options.',
      none: 'Aucun',
      select: 'Sélectionner',
      textLayerBorder: 'Bordure du calque texte',
      textBorderColor: 'Couleur bordure texte',
      textBackgroundColor: 'Couleur fond texte',
      textBorderWidth: 'Épaisseur bordure texte',
      textBorderRadius: 'Arrondi bordure texte',
      resetBorderColor: 'Réinitialiser couleur bordure',
      resetBackgroundColor: 'Réinitialiser couleur fond',
      resetTextBorderColor: 'Réinitialiser couleur bordure texte',
      resetTextBackgroundColor: 'Réinitialiser couleur fond texte',
      resetBodyBackgroundColor: 'Réinitialiser couleur fond corps',
      transparentColorDisabled: 'Color picker désactivé (transparent)',
      setOpaque: 'Rendre opaque',
      setTransparent: 'Rendre transparent',
      resetColor: 'Réinitialiser couleur',
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;
